{
  "chart": {
    "empty": {
      "description": "Geen gegevens beschikbaar voor deze periode.",
      "title": "Geen gegevens gevonden"
    }
  },
  "date_picker": {
    "all_time": "Alle tijd",
    "confirm": "Bevestigen",
    "date_range": "{startDate} - {endDate}",
    "last_n_days": "Afgelopen {days} dagen",
    "last_n_months": "Afgelopen {months} maanden",
    "today": "Vandaag"
  },
  "document_viewer": {
    "sidebar_heading": "Inhoudsoverzicht"
  },
  "dynamic_keys": {
    "saml": {
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    }
  },
  "editor": {
    "placeholder": "Schrijf iets",
    "placeholder_with_options": "Schrijf of typ '/' voor opties"
  },
  "error": {
    "title": "Er is een fout opgetreden."
  },
  "factor_indicator": {
    "average": "Gemiddeld",
    "bad": "Kritiek",
    "excellent": "Uitstekend",
    "good": "Goed"
  },
  "gauge_chart": {
    "empty": {
      "title": "Geen gegevens beschikbaar",
      "tooltip": "Je weerbaarheidsscore wordt berekend"
    }
  },
  "locale": {
    "current": "Nederlands",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "swedish": "Svenska"
  },
  "saml_provider_button": {
    "continue_with": "Doorgaan met {provider}"
  },
  "search": {
    "no_options": "Geen opties beschikbaar.",
    "no_results": "Geen resultaten gevonden.",
    "placeholder": "Zoeken..."
  },
  "simulations": {
    "expand_preview": {
      "close": "Voorbeeld sluiten",
      "open": "Voorbeeld uitvouwen"
    }
  },
  "video_player": {
    "captions": "Ondertiteling",
    "captions_off": "Uit",
    "normal_speed": "Normaal",
    "playback_speed": "Afspeelsnelheid"
  }
}
